import React, { ReactNode, useState } from 'react';
import Swiper from 'swiper/types/swiper-class';
import * as styles from './commentsPagination.module.scss';
import ArrowRightWhite from '../../../static/svg/arrow-right-white.svg';
import ArrowLeftWhite from '../../../static/svg/arrow-left-white.svg';

import 'swiper/scss/free-mode';
import 'swiper/scss/navigation';
import 'swiper/scss/thumbs';

interface Props {
  swiper: Swiper | undefined;
  swiper2?: Swiper;
  color: string;
  children?: ReactNode;
  setActiveIndex?: (i: number) => void;
  activeIndex?: number;
  length?: number;
}

export const CommentsPagination: React.FC<Props> = ({
  swiper,
  swiper2,
  color,
  children,
  length,
  activeIndex = 0,
  setActiveIndex,
}) => {
  return (
    <div className={styles.wrapper}>
      <div
        id="prevElSwiper"
        onClick={() => {
          swiper?.slidePrev();
          swiper2?.slidePrev();
        }}
        className={styles.prev}
        data-type={color}
      >
        <ArrowLeftWhite />
      </div>
      {children}
      <div
        id="nextElSwiper"
        onClick={() => {
          swiper?.slideNext();
          swiper2?.slideNext();
        }}
        className={styles.next}
        data-type={color}
      >
        <ArrowRightWhite />
      </div>
    </div>
  );
};
